// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-upload--dropzone{background-color:#e9fde8;padding:0 2rem;overflow:hidden}.btn-text{border:none;background:none;outline:none;cursor:pointer;padding:0}.btn-text+.btn-text{margin-left:1.5rem}.btn-text--primary{color:#4ae387}.btn-text--primary:hover{opacity:.6}.btn-text--secondary{color:#fff}@media(max-width:576px){.file-upload--dropzone{padding:0 1rem}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
